import {MAP_HEIGHT, MAP_WIDTH} from "~/components/TripMap/TripMap"

// NYC geography traced as SVG paths on the 658 x 1269 grid (provided design).
// The rivers + harbor are the water background; the boroughs are filled as land
// with Central Park and the High Line as parks.
// Reference: references/mta-subway-map.pdf.

// Manhattan is drawn in three filled pieces (north, mid, and downtown); the east
// boroughs (Queens + Brooklyn) are one piece across the East River.
const LAND_PATHS = [
    "M46 129V0H584V71.5294C584 74.712 585.264 77.7643 587.515 80.0147L633.485 125.985C635.736 128.236 637 131.288 637 134.471V197.529C637 200.712 635.736 203.764 633.485 206.015L514.515 324.985C512.264 327.236 509.212 328.5 506.029 328.5H280.971C277.788 328.5 274.736 327.236 272.485 324.985L145.015 197.515C142.764 195.264 141.5 192.212 141.5 189.029V153C141.5 146.373 136.127 141 129.5 141H58C51.3726 141 46 135.627 46 129Z",
    "M118.5 150.5H58C51.3726 150.5 46 155.873 46 162.5V735.529C46 738.712 47.2643 741.764 49.5147 744.015L232.985 927.485C235.236 929.736 238.288 931 241.471 931H279.529C282.712 931 285.764 929.736 288.015 927.485L398.985 816.515C401.236 814.264 402.5 811.212 402.5 808.029V696.471C402.5 693.288 401.236 690.236 398.985 687.985L352.515 641.515C350.264 639.264 349 636.212 349 633.029V350C349 343.373 343.627 338 337 338H274.471C271.288 338 268.236 336.736 265.985 334.485L134.015 202.515C131.764 200.264 130.5 197.212 130.5 194.029V162.5C130.5 155.873 125.127 150.5 118.5 150.5Z",
    "M279.5 1076.03V1001.5C279.5 994.873 274.127 989.5 267.5 989.5H135.971C132.788 989.5 129.736 990.764 127.485 993.015L85.5147 1034.99C83.2643 1037.24 82 1040.29 82 1043.47V1144.03C82 1147.21 80.7357 1150.26 78.4853 1152.51L49.5147 1181.49C47.2643 1183.74 46 1186.79 46 1189.97V1213C46 1219.63 51.3726 1225 58 1225H130.529C133.712 1225 136.764 1223.74 139.015 1221.49L275.985 1084.51C278.236 1082.26 279.5 1079.21 279.5 1076.03Z",
    "M591.992 334.608L658 270.5V1225H645.471C642.288 1225 639.236 1223.74 636.985 1221.49L605.515 1190.01C603.264 1187.76 600.212 1186.5 597.029 1186.5H447C440.373 1186.5 435 1181.13 435 1174.5V1059.97C435 1056.79 433.736 1053.74 431.485 1051.49L377.515 997.515C375.264 995.264 374 992.212 374 989.029V876.471C374 873.288 375.264 870.236 377.515 867.985L421.485 824.015C423.736 821.764 425 818.712 425 815.529V687.971C425 684.788 423.736 681.736 421.485 679.485L374.515 632.515C372.264 630.264 371 627.212 371 624.029V584V350C371 343.373 376.373 338 383 338H583.632C586.754 338 589.753 336.783 591.992 334.608Z",
]

// Parks: Central Park and the High Line.
const PARK_PATHS = [
    "M253 474.5V379.5C253 376.186 250.314 373.5 247 373.5H133C129.686 373.5 127 376.186 127 379.5V474.5C127 477.814 129.686 480.5 133 480.5H247C250.314 480.5 253 477.814 253 474.5Z",
    "M66.5 583.75V659.75C66.5 662.373 64.3734 664.5 61.75 664.5C59.1266 664.5 57 662.373 57 659.75V583.75C57 581.127 59.1266 579 61.75 579C64.3734 579 66.5 581.127 66.5 583.75Z",
]

const BaseMap = () => {
    return (
        <g aria-hidden="true" data-testid="base-map">
            <rect
                x={0}
                y={0}
                width={MAP_WIDTH}
                height={MAP_HEIGHT}
                fill="var(--color-mta-water)"
            />

            {LAND_PATHS.map((d, index) => (
                <path key={index} d={d} fill="var(--color-mta-paper)" />
            ))}

            {PARK_PATHS.map((d, index) => (
                <path key={index} d={d} fill="var(--color-mta-park)" />
            ))}
        </g>
    )
}

export default BaseMap
